import type { PubSub } from '../../PubSub';
import type { GameEvents } from '../../events';

export class Pause {
    constructor(private duration: number) {}

    execute(_pubsub: PubSub<GameEvents>, _flag: { cancelled: boolean }): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, this.duration));
    }
}
